(window as any).dataLayer = (window as any).dataLayer || [];

// gtags.js wants Arguments object arrays for some reason
/* eslint-disable */
export function gtag(...params: any[]) {
  (window as any).dataLayer.push(arguments);
}
